export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14051.9cdff3e5.jpg";